/*
 * HFS shared Slick wrapper (audit W22: GLB-13, JS-12, JS-13, COL-10, CNT-03, PDP-21, COL-11, JS-16).
 *
 * window.hfsCarousel($elements, slickOptions, { label: 'related products', pauseAfter: $container })
 *
 * Use it instead of calling .slick() directly. It:
 *  - turns autoplay off under prefers-reduced-motion: reduce (WCAG 2.2.2, 2.3.3);
 *  - adds a visible Pause / Play button (real <button>, label swaps between "Pause" and "Play") for every
 *    carousel that auto-advances, and only shows it while autoplay is actually active at the current
 *    breakpoint (some carousels autoplay only on small screens or unslick on large ones);
 *  - keeps the keyboard order clean, which Slick 1.8 does not: it removes the tabindex="0" Slick puts on
 *    every .slick-slide (an unnamed tab stop) and takes everything focusable out of the tab order inside
 *    aria-hidden slides and clones (Judge.me star badges, swatch radios, ...), restoring it when the slide
 *    is visible again (WCAG 2.4.3, 4.1.2);
 *  - names the arrow buttons after the carousel.
 * slick.min.js is not modified. Load after slick.min.js and before custom.js.
 */
(function (window) {
  'use strict';
  var $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.slick) return;

  var mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mql && mql.matches); }

  var FOCUSABLE = 'a[href],area[href],button,input,select,textarea,summary,iframe,[tabindex]';

  function mayAutoplay(options) {
    if (options.autoplay) return true;
    var r = options.responsive || [];
    for (var i = 0; i < r.length; i++) {
      if (r[i].settings && r[i].settings !== 'unslick' && r[i].settings.autoplay) return true;
    }
    return false;
  }

  function withoutAutoplay(options) {
    var o = $.extend({}, options, { autoplay: false });
    if (options.responsive) {
      o.responsive = $.map(options.responsive, function (r) {
        if (!r.settings || r.settings === 'unslick' || !('autoplay' in r.settings)) return [r];
        return [{ breakpoint: r.breakpoint, settings: $.extend({}, r.settings, { autoplay: false }) }];
      });
    }
    return o;
  }

  // Keyboard / accessibility-tree clean-up. Idempotent, cheap, run after every slide or layout change.
  function tidy($el, originalTabindex) {
    if (!$el.hasClass('slick-initialized')) {
      $el.find(FOCUSABLE).each(function () {
        if (!originalTabindex.has(this)) return;
        var original = originalTabindex.get(this);
        if (original === null) this.removeAttribute('tabindex'); else this.setAttribute('tabindex', original);
      });
      return;
    }

    var $clones = $el.find('.slick-cloned');
    $clones.each(function () {
      if (this.getAttribute('aria-hidden') !== 'true') this.setAttribute('aria-hidden', 'true');
      this.removeAttribute('id');
    });
    $clones.find('[id]').removeAttr('id');

    $el.find('.slick-slide').find(FOCUSABLE).addBack('.slick-slide').each(function () {
      var slide = this.closest('.slick-slide');
      var clone = slide.classList.contains('slick-cloned');
      if (!clone && !originalTabindex.has(this)) originalTabindex.set(this, this.getAttribute('tabindex'));
      if (clone || slide.getAttribute('aria-hidden') === 'true') {
        this.setAttribute('tabindex', '-1');
      } else {
        var original = originalTabindex.get(this);
        if (original === null) this.removeAttribute('tabindex'); else this.setAttribute('tabindex', original);
      }
    });
  }

  function init($els, options, cfg) {
    options = options || {};
    cfg = cfg || {};
    var label = cfg.label || 'carousel';

    $els.each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      // Slick rewrites descendants' tabindex during initADA; save author intent before it does so.
      var originalTabindex = new WeakMap();
      $el.find(FOCUSABLE).each(function () { originalTabindex.set(this, this.getAttribute('tabindex')); });
      $el.children().each(function () { originalTabindex.set(this, this.getAttribute('tabindex')); });

      var wantsAutoplay = mayAutoplay(options);
      var settings = (wantsAutoplay && reduced()) ? withoutAutoplay(options) : options;
      var userPaused = false;
      var $btn = null;

      function slickOf() { return $el[0] && $el[0].slick; }
      function playing() {
        var s = slickOf();
        return !!(s && $el.hasClass('slick-initialized') && s.options && s.options.autoplay && s.slideCount > s.options.slidesToShow);
      }
      function setButton(paused) {
        if (!$btn) return;
        $btn.find('.hfs-carousel-pause__text').text(paused ? 'Play' : 'Pause');
      }
      function sync() {
        tidy($el, originalTabindex);
        var s = slickOf();
        if (s) {
          $el.children('.slick-prev').attr('aria-label', 'Previous slide, ' + label);
          $el.children('.slick-next').attr('aria-label', 'Next slide, ' + label);
        }
        if ($btn) $btn.prop('hidden', !playing());
      }
      function keepUserPause() {
        // Slick starts autoplay after its init/reInit events, so re-apply the user's pause afterwards.
        if (!userPaused) return;
        setTimeout(function () { if (slickOf()) $el.slick('slickPause'); }, 0);
      }

      $el.on('init.hfs reInit.hfs breakpoint.hfs destroy.hfs afterChange.hfs setPosition.hfs', function (e) {
        sync();
        // initADA runs after Slick's init/afterChange event and otherwise overwrites this cleanup.
        Promise.resolve().then(function () { tidy($el, originalTabindex); });
        if (e.type === 'init' || e.type === 'reInit' || e.type === 'breakpoint') keepUserPause();
      });

      if (wantsAutoplay && !reduced()) {
        $btn = $('<button type="button" class="hfs-carousel-pause" hidden>' +
          '<span class="hfs-carousel-pause__text">Pause</span>' +
          '<span class="visually-hidden"></span></button>');
        $btn.find('.visually-hidden').text(' ' + label);
        if (cfg.pauseAfter && cfg.pauseAfter.length) cfg.pauseAfter.append($btn); else $btn.insertBefore($el);
        $btn.on('click', function () {
          if (!slickOf()) return;
          userPaused = !userPaused;
          $el.slick(userPaused ? 'slickPause' : 'slickPlay');
          setButton(userPaused);
        });
      }

      // The visitor can turn reduced motion on while the page is open.
      if (mql && wantsAutoplay) {
        var onChange = function () {
          if (!mql.matches || !slickOf()) return;
          userPaused = true;
          $el.slick('slickPause');
          setButton(true);
        };
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else if (mql.addListener) mql.addListener(onChange);
      }

      $el.slick(settings);
      sync();

      // Late content (Judge.me badges, recommendations) can add focusables after init.
      if (window.MutationObserver) {
        var queued = false;
        var mo = new MutationObserver(function () {
          if (queued) return;
          queued = true;
          (window.requestAnimationFrame || window.setTimeout)(function () {
            queued = false;
            mo.disconnect();
            tidy($el, originalTabindex);
            mo.observe($el[0], { childList: true, subtree: true });
          });
        });
        mo.observe($el[0], { childList: true, subtree: true });
      }
    });

    return $els;
  }

  window.hfsCarousel = init;
})(window);
